import Model from './model';

export default class EngagementAgreement extends Model {
  static NAME = 'engagement_agreement';
  static COLLECTION_NAME = "engagement_agreements";
  static URL = '/api/v2/engagement_agreements';

  // Clearances
  static CLEARANCES = [
    'Background Check',
    'Enhanced Reliability',
    'Secret',
    'Top Secret',
  ];
}